import { render, staticRenderFns } from "./forgotPasswordSVG.vue?vue&type=template&id=18848058&scoped=true"
import script from "./forgotPasswordSVG.vue?vue&type=script&lang=js"
export * from "./forgotPasswordSVG.vue?vue&type=script&lang=js"
import style0 from "./forgotPasswordSVG.vue?vue&type=style&index=0&id=18848058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18848058",
  null
  
)

export default component.exports